import React, { useEffect } from "react";  
import { useHistory } from 'react-router-dom';

import { Row, Col } from 'reactstrap';   
import { ReadObject } from "services/storage"; 
import { ThemedComponent } from "ui/theme";

import {
    SideBackgroundImageContainer,
    SideBackgroundImage,
    SideBackgroundImageDegree,

    FormContent,
    AppLogo,
    Content,
    Touch
} from './styled'
 

export default function ContainerUnauthenticated({ children, reverse }){   
    
    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);

    const init = () => {
        const authentication = ReadObject('authentication')
        if (authentication?.jwt) {
            completeNext()
        }
    }
 
    const completeNext = () => {
        navigate('dashboard')
    }

    useEffect(() => {  
        init()
        window.scrollTo(0,0)
    }, [])

    return ( 
        <> 
            <ThemedComponent>
                <Content>
                    <Row>
                        {
                            reverse ? null :
                            <Col md={{ size:6 }}>
                                <SideBackgroundImageContainer>
                                    <SideBackgroundImage />
                                </SideBackgroundImageContainer>
                            </Col>
                        }
                        <Col md={{ size:6 }}>
                            <FormContent reverse={reverse}> 
                                { children }
                            </FormContent>
                        </Col>
                        {
                            !reverse ? null :
                            <Col md={{ size:6 }}>
                                <SideBackgroundImageContainer>
                                    <SideBackgroundImage />
                                </SideBackgroundImageContainer>
                            </Col>
                        }
                    </Row>  
                </Content>
            </ThemedComponent>
        </>
    );
}